import React from 'react';
import { motion } from 'framer-motion';
import Slider from "react-slick";
import { Link } from 'react-router-dom'; // Ensure you use React Router for navigation
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../Contact/Contact.scss';
import sliderImage from '../img/bg c.jpeg';

const ContactPage = () => {
    const initMap = () => {
        const map = new window.google.maps.Map(document.getElementById('map'), {
            center: { lat: 28.6067013, lng: 77.431963 },
            zoom: 15,
            mapTypeControl: false,
            disableDefaultUI: true,
        });

        new window.google.maps.Marker({
            position: { lat: 28.6067013, lng: 77.431963 },
            map: map,
            title: "Care Health Nurses Pvt Ltd",
        });
    };

    React.useEffect(() => {
        if (window.google) {
            initMap();
        }
    }, []);

    const formVariants = {
        hidden: { opacity: 0, x: -100 },
        visible: { opacity: 1, x: 0, transition: { duration: 0.8 } },
    };

    const detailsVariants = {
        hidden: { opacity: 0, y: 50 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
    };

    // Slider settings
    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        cssEase: "ease-in-out",
        fade: true,
        arrows: true,
        adaptiveHeight: true,
        pauseOnHover: true,
    };

    
    return (
        <div className="contact-page">
            {/* Slider Section */}
            <div className="slider-container">
                <Slider {...sliderSettings}>
                    {[sliderImage].map((image, index) => (
                        <div key={index} className="relative">
                            <img
                                src={image}
                                alt={` # `}
                                className="w-full h-auto rounded-lg shadow-md"
                            />
                            <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity duration-300">
                                {/* Links Overlay */}
                                <div className="text-center">
                                    <Link
                                        to="/"
                                        className="text-white text-xl bg-blue-500 px-4 py-2 rounded hover:bg-blue-700 transition"
                                    >
                                        Home
                                    </Link>
                                    <Link
                                        to="/contact"
                                        className="text-white text-xl bg-green-500 px-4 py-2 rounded ml-4 hover:bg-green-700 transition"
                                    >
                                        Contact
                                    </Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>

            {/* Contact Form and Details */}
            <motion.div
                className="row"
                initial="hidden"
                animate="visible"
                exit="hidden"
            >
                {/* Left Side: Contact Form */}
                <motion.div id="left" variants={formVariants}>
                    <h1>Contact Us</h1>
                    <div className="formbox">
                        <form>
                            <input name="name" type="text" className="short" placeholder="Name" />
                            <input name="email" type="email" className="short" placeholder="Email" />
                            <input name="phone" type="tel" className="short" placeholder="Phone" />
                            <input name="subject" type="text" className="feedback-input" placeholder="Subject" />
                            <textarea name="text" className="feedback-input" placeholder="Message"></textarea>
                            <motion.input
                                type="submit"
                                value="SEND"
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.95 }}
                                className="submit-button"
                            />
                        </form>
                    </div>
                </motion.div>

                {/* Right Side: Contact Details */}
                <motion.div id="right" variants={detailsVariants}>
                    <div id="map-overlap">
                        <h2>Head Office Address</h2>
                        <p>
                            1/21 Gali No.1, Lalita Park, <br />
                            Laxmi Nagar, Delhi: 110092
                        </p>
                        <p>
                            <strong>Email:</strong> CareHealthNurses@gmail.com<br />
                            <strong>Phone:</strong> +91-9999790231 / +91-9999407473
                        </p>
                        <p>Providing reliable nursing services with care and compassion.</p>
                    </div>
                    <div id="map" style={{ height: "300px", marginTop: "20px" }}></div>
                </motion.div>
            </motion.div>
        </div>
    );
};

export default ContactPage;
